import React from 'react'
import {DropboxCreation} from '../../containers'

export default function DropboxCreationScreen() {
  return <DropboxCreation />
}
